// Project
import { toCurrency } from 'src/utils/stringFormatter';

export const Amount = ({ value }) => (
  <div className="flex max-w-[100px] justify-between">
    <span>$</span> {toCurrency(value)}
  </div>
);
